import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';

import { useCookiePolicy } from '@/components/ui/cookie-policy';
import { PageLoader } from '@/components/ui/pageloader';
import { GOOGLE_SIGNIN_URL } from '@/config/endpoints';
import { paths } from '@/config/paths';
import { useUserProfile } from '@/features/user/api/get-user-profile';
import { getPhase } from '@/utils/phase';

const ProtectedRoute = () => {
  const phase = getPhase();
  const { accepted: cookiePolicyAccepted } = useCookiePolicy();
  const navigate = useNavigate();
  const userProfileQuery = useUserProfile({});
  const userProfile = userProfileQuery.data?.contents ?? false;
  const isLoggedIn = userProfile !== false;

  useEffect(() => {
    if (!cookiePolicyAccepted) {
      // Cookie policy must be accepted.
      navigate(paths.home.getHref());
    } else if (userProfileQuery.status === 'success' && !isLoggedIn) {
      // Login is required
      window.location.replace(GOOGLE_SIGNIN_URL[phase]);
    }
  }, [phase, cookiePolicyAccepted, navigate, userProfileQuery, isLoggedIn]);

  return isLoggedIn ? <Outlet /> : <PageLoader show />;
};

ProtectedRoute.displayName = 'ProtectedRoute';

export { ProtectedRoute };
